import axios from 'axios';
import { API_BASE_URL } from './utils/apiBase';

const api = axios.create({
  baseURL: API_BASE_URL || undefined, // if empty, requests MUST be absolute
  headers: { 'Content-Type': 'application/json' },
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err?.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      // optional: window.location = '/login';
    }
    return Promise.reject(err);
  }
);

if (!API_BASE_URL && typeof window !== 'undefined') {
  // eslint-disable-next-line no-console
  console.warn('[api] API_BASE_URL is empty – set REACT_APP_API_BASE_URL.');
}

export default api;
